export default [
  {
    header: 'Levels & Locations',
    title: 'Levels & Locations',
    icon: 'LayersIcon',
    route: 'levels-locations-list',
    resource: 'AdminAccess',
  },
]
